import React from 'react';
import { Container } from '@soluto-design/react';

import { ButtonProps } from '@soluto-design/react';

import BlockTitleLarge, {
    BlockTitleLargeProps,
} from '../../molecules/BlockTitleLarge';

export interface BlockTitleLargeSectionProps
    extends Omit<BlockTitleLargeProps, 'rating'> {
    rating?: number;
    ratingLink?: ButtonProps;
}

export default function BlockTitleLargeSection({
    rating,
    ratingLink,
    ...props
}: BlockTitleLargeSectionProps) {
    return (
        <section className="my-xxxl">
            <Container className="row">
                <div className="col-span-full lg:col-span-6 xl:col-span-8 hd:col-span-7">
                    <BlockTitleLarge
                        titleTag="h2"
                        preTitleTag="p"
                        {...(!!rating && {
                            rating: { value: rating, link: ratingLink },
                        })}
                        {...props}
                    />
                </div>
            </Container>
        </section>
    );
}
